import {AuditDTO} from "../../shared/components/audit/audit.types";
import {PageDTO} from "../../core/types/pagination.types";

export enum RecallStatus {
    SCHEDULED = 'SCHEDULED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    REFUSED = 'REFUSED'
}

export enum RecallUserResponse {
    ACCEPTED = 'ACCEPTED',
    NOT_ACCEPTED = 'NOT_ACCEPTED',
    NO_RESPONSE = 'NO_RESPONSE',
    MOVED_AWAY = 'MOVED_AWAY',
    FINANCIAL_REASONS = 'FINANCIAL_REASONS',
    DENTAL_ANXIETY = 'DENTAL_ANXIETY',
    TOO_BUSY = 'TOO_BUSY',
    HEALTH_ISSUES = 'HEALTH_ISSUES',
    OTHER_DENTIST = 'OTHER_DENTIST',
    NO_LONGER_NEEDED = 'NO_LONGER_NEEDED'
}

export enum RecallType {
    TREATMENT_BASED = 'TREATMENT_BASED',
    EVENT_BASED = 'EVENT_BASED',
    CUSTOM = 'CUSTOM',
}

export enum RecallTemplate {
    GENERIC_SMS_TEMPLATE = 'GENERIC_SMS_TEMPLATE',
    GENERIC_EMAIL_TEMPLATE = 'GENERIC_EMAIL_TEMPLATE',
}

export class CustomRecall {
    recallUserId: string;
    doctorId: string;
    name: string;
    recallDate: string;
}

export class RecallMsg {
    template: RecallTemplate;
    content: string;
}

export interface RecallUpdateDTO {
    id: string; // uuid
    recallDate?: string; // date
    status?: RecallStatus;
    userResponse?: RecallUserResponse;
    name?: string;
    assignedUserId?: string; // uuid
    details?: string;
}

export interface RecallResponseDTO extends AuditDTO{
    id?: string; // uuid
    recallDate?: string; // date
    type?: RecallType;
    userResponse?: RecallUserResponse;
    template?: RecallTemplate;
    status?: RecallStatus;
    recallUserId?: string; // uuid
    patientEmail?: string;
    patientPhoneNumber?: string;
    patientName?: string;
    doctorId?: string; // uuid
    treatmentId?: string; // uuid
    eventId?: string; // uuid
    name?: string;
    details?: string;
}

export class RecallResponseDTOPage extends PageDTO{
    content: RecallResponseDTO[];
}

export function createRecallResponseDTO(): RecallResponseDTO {
    return {
        id: '',
        recallDate: '',
        type: RecallType.TREATMENT_BASED,
        userResponse: RecallUserResponse.NO_RESPONSE,
        template: RecallTemplate.GENERIC_SMS_TEMPLATE,
        status: RecallStatus.SCHEDULED,
        recallUserId: '',
        patientEmail: '',
        patientPhoneNumber: '',
        patientName: '',
        doctorId: '',
        treatmentId: '',
        eventId: '',
        name: '',
        details: '',
        createdOn: '',
        createdBy: '',
        updatedOn: '',
        updatedBy: ''
    };
}





